module.exports = __webpack_public_path__ + "img/canvas.0af663f0.png";